export const getUsersAndOther = (id, conversationData) => {

  var users = Object.keys(conversationData).reduce((users, key) => {

    if (key.indexOf('user-') > -1) {

      return [...users, key.substring(key.indexOf('-') + 1)]

    } else {
      return [...users]
    }
  }, [])

  console.log("FOUND USERS ", users);

  var other = users.filter(userId => userId != id)[0];

  return {
    users,
    other
  }

}


// WEBPACK FOOTER //
// ./src/Components/Conversations/middleware/utils.js